var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "My Bids",
        visible: _vm.isOpen,
        width: "50%",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
        footer: null,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "common-table",
          attrs: { data: _vm.tableList, "highlight-current-row": "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "data1", label: "Serial number" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var $index = ref.$index
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.tableList.length - $index) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "data2", label: "Time" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm
                            .moment(row.timestamp)
                            .format("YYYY-MM-DD HH:mm:ss")
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "data3", label: "Bid price", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("big-number", { attrs: { number: row.amount } }),
                    _c("span", { staticClass: "td-word-sm" }, [
                      _vm._v("TCash"),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }